import React, { useEffect, useState } from 'react';
import { Check, X } from 'lucide-react';
const buyers = [{
  name: 'Luca M.',
  location: 'Torino',
  minutes: 4
}, {
  name: 'Giulia R.',
  location: 'Milano',
  minutes: 12
}, {
  name: 'Matteo K.',
  location: 'Roma',
  minutes: 23
}, {
  name: 'Sofia M.',
  location: 'Napoli',
  minutes: 7
}, {
  name: 'Andrea P.',
  location: 'Firenze',
  minutes: 18
}];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(showTimer);
  }, []);
  useEffect(() => {
    if (!visible) return;
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx(i => (i + 1) % buyers.length);
        setVisible(true);
      }, 800);
    }, 9000);
    return () => clearInterval(cycle);
  }, [visible]);
  const buyer = buyers[idx];
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`} data-id="element-189">
      <div className="bg-white rounded-2xl shadow-xl border border-volley-navy/5 p-3 pr-4 flex items-center gap-3 max-w-[300px]" data-id="element-190">
        <div className="bg-volley-teal w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-191">
          <Check className="w-5 h-5 text-white" strokeWidth={3} data-id="element-192" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-193">
          <p className="text-sm font-semibold text-volley-navy leading-tight truncate" data-id="element-194">
            {buyer.name}, da {buyer.location}
          </p>
          <p className="text-xs text-volley-slate leading-tight mt-0.5" data-id="element-195">
            Ha appena acquistato • {buyer.minutes} min fa •{' '}
            <span className="text-volley-teal-dark font-semibold" data-id="element-196">
              Acquisto Verificato
            </span>
          </p>
        </div>
        <button onClick={() => setVisible(false)} className="text-volley-gray hover:text-volley-navy transition-colors flex-shrink-0" aria-label="Close" data-id="element-197">
          <X className="w-4 h-4" data-id="element-198" />
        </button>
      </div>
    </div>;
}